export default "__VITE_ASSET__Bcjo_Pfa__"